import startIcon from '../../../images/map-icons/start_icon@2x.png';
import stopIcon from '../../../images/map-icons/stop_icon@2x.png';
import warningIcon from '../../../images/map-icons/warning_icon@2x.png';

const OTHER_ICON_MAP = {
  start: { src: startIcon },
  stop: { src: stopIcon },
  warning: { src: warningIcon },
};

/**
 * Returns the artwork definition for a non-device map annotation.
 */
const getOtherIcon = type => OTHER_ICON_MAP[type];

export { getOtherIcon };
